import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const LogoutButton = () => {
  const { baseUrl } = useStore();

  return (
    <a
      className={cx("profile-button", "logout-button")}
      href={`https://id.${baseUrl}/logout/?next=${encodeURIComponent(
        window.location.href
      )}&utm_source=header&utm_campaign=new_header`}
      onClick={() => sendNavigationMetric("LOGOUT")}
    >
      {strings.profile_logout}
    </a>
  );
};

export default observer(LogoutButton);
